import React, { useEffect, useState } from 'react';
import { Colors } from '../../constants/colors.constants';
import MembersList from './MembersList/MembersList.tsx';
import { type Member } from '../../assets/js/collaborative_space';
import { PencilIcon } from '../../icons/Icons.jsx';
import { CollaborativeSpace } from '../../assets/js/collaborative_space/collaborative_space.ts';
import { getCurrentUser } from '../../utils/userUtils';
import './CollaborativeSpaceMembers.scss';
import { sentryLogger } from '../../monitor/monitor.js';

const CollaborativeSpaceMembers = ({ spaceName }) => {
  const [editingMembers, setEditingMembers] = useState<Member[]>([]);
  const [viewingMembers, setViewingMembers] = useState<Member[]>([]);

  useEffect(() => {
    const loadMembers = async () => {
      try {
        const space = await CollaborativeSpace.setCurrentSpace(spaceName);

        // Listen to members updates
        space?.members.subscribe('update', async () => {
          try {
            const members = await space.members.getAll();
            const editing: Member[] = [];
            const viewing: Member[] = [];
            members.forEach((member) => {
              if (!member.isConnected) {
                return;
              }
              if (member.profileData?.isEditing) {
                editing.push(member as Member);
                return;
              }
              viewing.push(member as Member);
            });
            setEditingMembers(editing);
            setViewingMembers(viewing);
          } catch (error) {
            sentryLogger.error('Error getting members:', error);
          }
        });

        // Enter to the space
        const currentUser = getCurrentUser();
        const profileData = {
          name: currentUser.name,
          lastname: currentUser.lastname,
          fullName: `${currentUser.name || ''} ${currentUser.lastname || ''}`,
          email: currentUser.email,
          role: currentUser.role,
          avatarUrl: currentUser.image
        };

        await space.enter(profileData);
      } catch (error) {
        sentryLogger.error('Error getting space:', error);
      }
    };

    loadMembers();

    return () => {
      CollaborativeSpace.leaveSpace();
    };
  }, [spaceName]);

  return (
    <div className="collaborative-space-members">
      {editingMembers.length > 0 && (
        <div className="collaborative-space-members__editing">
          <MembersList members={editingMembers} maxMembers={3} />
          <PencilIcon
            color={Colors.BLUE}
            className="collaborative-space-members__edit-icon"
          />
        </div>
      )}
      <MembersList members={viewingMembers} />
    </div>
  );
};

export default CollaborativeSpaceMembers;
